/**
 * 自动生成， 请不要手工修改！
 */

import {MessageType} from "../../MessageContentType";
import {RequestStatus} from "../../../datatype/request/RequestStatus";
import { TypeFactory } from "../../../serialize/TypeFactory";
import { GenericEntityMessage } from "@/services/message/entity/api/GenericEntityMessage";

export abstract class AbstractRequestStatusMessage extends GenericEntityMessage<RequestStatus> {
    constructor() {
        super();
    }

    public getContentType(): MessageType {
        return MessageType.REQ_STATUS;
    }

    public fillFromJson(json: Object, factory?: TypeFactory) {
        if (factory) {
            super.fillFromJson(json, factory);
        } else {
            super.fillFromJson(json);
        }
    }

  public fillToJson(json: Object, includeTypeTag = true) {
    super.fillToJson(json, includeTypeTag);

    if (includeTypeTag) {
      json["__type"] = "RequestStatusMessage";
    }
  }

  public getTypeId(): string {
    return "RequestStatusMessage";
  }

  public getClassName(): string {
    return "com.gong_wei.common.message.entity.request.RequestStatusMessage";
  }
}
